import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/components/base.component';

@Component({
    selector: 'hero-component',
    standalone: true,
    imports: [...BaseComponent.BaseImports],
    templateUrl: './HeroComponent.html',
    styleUrl: './HeroComponent.css',
})

export class HeroComponent implements BaseComponent, OnInit
{
    constructor()
    {
    }

    async ngOnInit()
    {
    }
}
